export default __webpack_public_path__ + "static/media/thumbnail.4ac36698.png";